export default __webpack_public_path__ + "static/media/category_product_crud.5cbbc75c.PNG";